/** Uklanja binId iz skeniranog barkoda naljepnice (npr. "16-3-2/1631" -> "16-3-2"). */
export function normalizeScannedBinCode(code: string): string {
  return code.trim().replace(/\/\d+$/, "");
}

export function formatBinLabelForDisplay(label: string): string {
  return normalizeScannedBinCode(label);
}
